import React from 'react';
import { $IconWrapper } from './styles';
import { FORM_ELEMENT_TYPES, SvgIcon } from '../';
export const ElementIcon = ({ size = 16, color = '#757778', type, title }) => {
    const icon = () => {
        switch (type) {
            case FORM_ELEMENT_TYPES.INSTRUCTIONS:
            case FORM_ELEMENT_TYPES.DOCUMENT_PREVIEW:
                return React.createElement(SvgIcon, { name: 'description-outlined', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.MULTISELECT:
            case FORM_ELEMENT_TYPES.SELECT:
                return React.createElement(SvgIcon, { name: 'dropdown', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.SELECT_PARTITION:
                return React.createElement(SvgIcon, { name: 'database', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.PARTITION_RESOURCES:
                return React.createElement(SvgIcon, { name: 'memory', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.TOGGLE:
                return React.createElement(SvgIcon, { name: 'toggle', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.CHECKBOX:
                return React.createElement(SvgIcon, { name: 'checkbox', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.UPLOAD:
                return React.createElement(SvgIcon, { name: 'upload', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.PHONE_NUMBER:
                return React.createElement(SvgIcon, { name: 'phone', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.NUMBER:
                return React.createElement(SvgIcon, { name: 'number', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.DATE:
                return React.createElement(SvgIcon, { name: 'calendar', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.GROUP: {
                switch (title) {
                    case 'Review Upload':
                        return React.createElement(SvgIcon, { name: 'upload', color: color, size: 24 });
                    case 'Scientific Reviewer':
                    case 'Research Field':
                        return React.createElement(SvgIcon, { name: 'research', color: color, size: 24 });
                    case 'Add Code':
                        return React.createElement(SvgIcon, { name: 'qrcode', color: color, size: 24 });
                    case 'Partitions':
                    case 'Partitions Award':
                        return React.createElement(SvgIcon, { name: 'database', color: color, size: 24 });
                    case 'Team Members':
                        return React.createElement(SvgIcon, { name: 'team', color: color, size: 24 });
                    default:
                        return React.createElement(SvgIcon, { name: 'hive', color: color, size: 24 });
                }
            }
            case FORM_ELEMENT_TYPES.SPACE:
                return React.createElement(SvgIcon, { name: 'space', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.DIVIDER:
                return React.createElement(SvgIcon, { name: 'divider', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.PREVIEW:
                return React.createElement(SvgIcon, { name: 'content-copy', color: color, size: 24 });
            case FORM_ELEMENT_TYPES.EMAIL:
                return React.createElement(SvgIcon, { name: 'email', color: color, size: 24 });
            default:
                return React.createElement(SvgIcon, { name: 'text-fields', color: color, size: 24 });
        }
    };
    return React.createElement($IconWrapper, { color: color, size: size }, icon());
};
